import type { HTMLAttributes } from 'react';
import { clsx } from '../clsx';
import styles from './Eyebrow.module.css';

export interface EyebrowProps extends HTMLAttributes<HTMLSpanElement> {
  /** 10 px is the label of tables, cards and dialogs; 11 px the section eyebrow of pages (`--text-2xs`). */
  size?: 10 | 11 | undefined;
  as?: 'span' | 'div' | undefined;
}

/** Small tracked uppercase label of the screens (eyebrow above titles, table headers, groups). */
export function Eyebrow({ size = 10, as: Tag = 'span', className, ...rest }: EyebrowProps) {
  return <Tag className={clsx(styles.eyebrow, size === 11 && styles.large, className)} {...rest} />;
}
